// --- Audio playback for ephemeral cube interactions ---
// Hard-coded track list (files located in public/audio). Both ogg and mp3 variants included.
const audioTracks: string[] = [
  "/audio/File-MMX-STING_CHAMELEAO_STAGE.ogg",
  "/audio/fx_mixdown.mp3",
  "/audio/File-MMX-BURNIN_NOUMANDER_STAGE.ogg",
  "/audio/File-MMX-SIGMA_STAGE_3.ogg",
  "/audio/File-MMX-SPARK_MANDRILLER_STAGE.ogg",
  "/audio/File-MMX-ZERO.ogg",
  "/audio/File-MMX-BOOMER_KUWANGER_STAGE.ogg",
  "/audio/MMX-SIGMA_1st.ogg",
  "/audio/bodenstaendig_2000_in_rock_4bit.ogg",
  "/audio/File-MMX-DEMO.ogg",
  "/audio/fx_mixdown.ogg",
  "/audio/File-MMX-OPENING_STAGE.ogg",
  "/audio/File-MMX-ICY_PENGUIGO_STAGE.ogg",
  "/audio/File-FortesTheme-MM7.ogg",
  "/audio/bodenstaendig_2000_in_rock_4bit.mp3",
  "/audio/File-MMX-SIGMA_2nd.ogg",
  "/audio/File-MMX-ARMOR_ARMARGE_STAGE.ogg",
  "/audio/File-MMX-STORM_EAGLEED_STAGE.ogg",
  "/audio/MMX-LAUNCHER_OCTOPULD_STAGE.ogg",
];

let currentAudio: HTMLAudioElement | null = null;
let currentTrackIndex = -1;

export const playRandomTrack = () => {
  if (!audioTracks.length) return;
  let nextIndex = Math.floor(Math.random() * audioTracks.length);
  if (audioTracks.length > 1) {
    // Ensure a different track than current when possible
    let safety = 10;
    while (nextIndex === currentTrackIndex && safety-- > 0) {
      nextIndex = Math.floor(Math.random() * audioTracks.length);
    }
  }
  currentTrackIndex = nextIndex;
  if (currentAudio) {
    try {
      currentAudio.pause();
    } catch {}
  }
  const audio = new Audio(audioTracks[nextIndex]);
  audio.loop = true;
  audio.volume = 0.6; // moderate volume
  currentAudio = audio;
  // Attempt play; catch to avoid unhandled promise if autoplay policies block (should be user initiated though)
  audio.play().catch((err) => {
    // eslint-disable-next-line no-console
    console.warn("Audio play failed", err);
  });

  return currentAudio;
};
